var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFadedClouds = function SvgFadedClouds(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 31,
    viewBox: "0 0 240 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M0 32V19.656C9.558 13.736 20.718 11.0773 31.6 12.1893C45.672 13.6213 58.866 21.072 72.96 22.1893C87.728 23.352 102.468 17.688 116.6 12.7867C130.454 7.98666 144.26 6.152 158.48 9.29867C165.71 10.8987 172.45 14.056 179.37 17.1227C197.898 25.3333 222.6 35.8107 240 18.008V32H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 32V27.784C2.6 22.1547 5.528 16.8373 9.538 12.7867C19.882 2.328 33 2.4 44.916 7.57867C51.146 10.2853 56.934 14.5307 62.85 18.192C71.034 23.2587 79.796 30.4587 89.016 31.4373C96.268 32.1973 103.196 28.9253 108.736 23.0213C115.09 16.2507 121.2 6.488 129.462 3.55467C137.55 0.677336 145.732 5.33867 153.288 10.0293C160.844 14.72 168.32 20.4293 176.672 21.5093C188.618 23.0693 199.328 15.408 210.452 11.152C216.492 8.84267 222.252 9.50667 227.87 13.152C232.356 16.056 237.47 20.3333 240 26.2827V32H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32V30.4987C29.986 16.2667 62.818 12.9813 95.166 20.648C103.766 22.6853 112.012 26.0133 120.688 27.704C132.488 30.0053 143.184 24.44 153.8 18.264C165.586 11.408 177.2 6.60266 190.24 8C207.546 9.86666 224.732 20.1893 240 30.616V32H0Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFadedClouds);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "faded-clouds.b0f120df08984f2c68550e40adcccbfb.svg";